// Force bundle invalidation - timestamp: 2026-01-12T00:00:00Z
export const BUILD_TIMESTAMP = new Date('2026-01-12T00:00:00Z').getTime();
